export default __webpack_public_path__ + "static/media/2-6-2.350b2f58.jpg";